import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import { NotificationManager } from "react-notifications";
import getFilterServices from "../../../services/getFilterServices";

const AddEdit = ({
  open,
  setOpen,
  dialogType,
  editValue,
  setEditValue,
  fetchData,
}) => {
  const [loading, setLoading] = useState(false);

  const validationSchema = Yup.object().shape({
    serviceName: Yup.string().required("Service name is required"),
  });

  const formik = useFormik({
    initialValues: {
      serviceName: editValue?.serviceName || "",
    },
    validationSchema,
    enableReinitialize: true,
    onSubmit: async (values) => {
      setLoading(true);
      try {
        let response;
        if (dialogType === "add") {
          response = await getFilterServices.AddService({
            serviceName: values.serviceName,
          });
        } else {
          response = await getFilterServices.UpdateService({
            serviceName: values.serviceName,
            serviceId: editValue.serviceId,
          });
        }

        console.log("response--services", response);

        if (response?.success) {
      
          handleClose();
          fetchData();
        } 
      } catch (error) {
        console.error("Error:", error);
        NotificationManager.error(
          `Error ${dialogType === "add" ? "adding" : "updating"} service`,
          "Error"
        );
      } finally {
        setLoading(false);
      }
    },
  });

  const handleClose = () => {
    setOpen(false);
    setEditValue(null);
    formik.resetForm();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          minHeight: "300px",
          "& .MuiDialogContent-root": {
            padding: "20px 24px",
          },
          "& .MuiDialogActions-root": {
            padding: "16px 24px",
          },
        },
      }}
    >
      <DialogTitle sx={{ fontSize: "1.5rem", fontWeight: 600 }}>
        {dialogType === "add" ? "Add Service" : "Edit Service"}
      </DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <TextField
            fullWidth
            margin="normal"
            name="serviceName"
            label="Service Name"
            value={formik.values.serviceName}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.serviceName && Boolean(formik.errors.serviceName)
            }
            helperText={formik.touched.serviceName && formik.errors.serviceName}
            sx={{
              "& .MuiInputBase-root": {
                height: "48px",
              },
              "& .MuiInputLabel-root": {
                fontSize: "1rem",
              },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button
            onClick={handleClose}
            sx={{
              fontSize: "1rem",
              padding: "8px 16px",
            }}
          >
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={loading}
            sx={{
              fontSize: "1rem",
              padding: "8px 16px",
            }}
          >
            {dialogType === "add" ? "Add" : "Update"}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default AddEdit;
